import {createRouter, createWebHistory} from 'vue-router'

const routes = [
    {
        path: '/ppomppu',
        component: () => import (/* webpackChunkName: "ppomppu" */'@/layouts/front/LayoutPpomppu.vue'),
        children: [
            {
                path: '/ppomppu',
                name: 'ppomppu',
                component: () => import (/* webpackChunkName: "ppomppu" */'@/views/front/ppomppu/PpomppuFrame.vue')
            },
            {
                path: '/ppomppu/:boardId',
                component: () => import (/* webpackChunkName: "ppomppu" */'@/views/front/ppomppu/PpomppuList.vue')
            }
        ]
    },
    {
        path: '/coin',
        component: () => import (/* webpackChunkName: "coin" */'@/layouts/front/LayoutCoin.vue'),
        children: [
            {
                path: '/coin',
                name: 'coin',
                component: () => import (/* webpackChunkName: "coin" */'@/views/front/coin/CoinList.vue')
            }
        ]
    },
    {
        path: '/ktoa',
        component: () => import (/* webpackChunkName: "ktoa" */'@/layouts/front/LayoutKtoa.vue'),
        children: [
            {
                path: '/ktoa',
                name: 'ktoa',
                component: () => import (/* webpackChunkName: "ktoa" */'@/views/front/ktoa/KtoaMain.vue')
            }
        ]
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// router.beforeEach((to, from, next) => {
//     const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
//     if (requiresAuth && !isAuthenticated) {
//         next("/login");
//     } else {
//         next();
//     }
// });

export default router
